import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { supabase } from '../lib/supabase'
import { getTierByCi } from '../lib/press'

// ── PressLeaderboard ──────────────────────────────────────────
// Shown on Culture and Journal pages — highlights top writers
// by rank to make the progression system visible and aspirational.

export default function PressLeaderboard() {
  const [writers, setWriters] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    supabase
      .from('profiles')
      .select('id, display_name, column_inches, is_voice, press_theme')
      .or('column_inches.gt.0,is_voice.eq.true')
      .order('column_inches', { ascending: false })
      .limit(8)
      .then(({ data }) => {
        setWriters(data || [])
        setLoading(false)
      })
  }, [])

  if (loading || writers.length === 0) return null

  return (
    <div style={{
      borderTop: '1px solid var(--rule)',
      borderBottom: '1px solid var(--rule)',
      background: 'var(--cream)',
      padding: '1.25rem 0',
      overflow: 'hidden',
    }}>
      <div style={{
        maxWidth: 860,
        margin: '0 auto',
        padding: '0 3rem',
      }}>
        {/* Label */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '1rem',
          marginBottom: '0.9rem',
        }}>
          <span style={{
            fontFamily: "'Courier New', monospace",
            fontSize: '0.58rem',
            letterSpacing: '0.18em',
            textTransform: 'uppercase',
            color: 'var(--accent)',
          }}>
            The Press — Top Writers
          </span>
          <div style={{ flex: 1, height: 1, background: 'var(--rule)' }} />
          <Link to="/feed" style={{
            fontFamily: "'Courier New', monospace",
            fontSize: '0.55rem',
            letterSpacing: '0.1em',
            color: 'var(--muted)',
            textTransform: 'uppercase',
          }}>
            View all →
          </Link>
        </div>

        {/* Writer chips */}
        <div style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '0.5rem',
        }}>
          {writers.map(w => {
            const tier = getTierByCi(w.column_inches || 0, w.is_voice)
            return (
              <Link
                key={w.id}
                to={`/writer/${w.id}`}
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '0.5rem',
                  padding: '0.35rem 0.75rem',
                  border: `1px solid ${w.is_voice ? '#C8401A' : tier.rank >= 8 ? tier.color : 'var(--rule)'}`,
                  background: w.is_voice
                    ? 'rgba(200,64,26,0.05)'
                    : tier.rank >= 8
                    ? `color-mix(in srgb, ${tier.color} 6%, transparent)`
                    : 'var(--paper)',
                  transition: 'all 0.15s',
                  textDecoration: 'none',
                }}
              >
                {/* Tier badge symbol */}
                <span style={{
                  fontFamily: "'Space Grotesk', sans-serif",
                  fontSize: '0.8rem',
                  color: tier.color,
                  lineHeight: 1,
                }}>
                  {tier.badge}
                </span>
                {/* Name */}
                <span style={{
                  fontFamily: "'Courier New', monospace",
                  fontSize: '0.65rem',
                  letterSpacing: '0.04em',
                  color: 'var(--ink)',
                }}>
                  {w.display_name}
                </span>
                {/* Tier indicator */}
                <span style={{
                  fontFamily: "'Courier New', monospace",
                  fontSize: '0.5rem',
                  letterSpacing: '0.1em',
                  color: tier.color,
                  opacity: 0.8,
                }}>
                  {tier.indicator}
                </span>
              </Link>
            )
          })}
        </div>
      </div>
    </div>
  )
}
